import React from 'react';
import { CheckmarkCircleIcon } from '@glu/icons-react';

import Checkbox from '../../../checkbox/Checkbox';

const getFormattedValue = (value) => (
  <div className="icon-wrapper">{value ? <CheckmarkCircleIcon /> : '-'}</div>
);

const formatDateWithSeparator = (format, { fileSeparator }) => {
  const regex = /(DD|MM|YYYY|YY)/g;
  let match;
  let str = '';
  const separator = fileSeparator !== 'no' ? fileSeparator : '';

  // eslint-disable-next-line no-cond-assign
  while ((match = regex.exec(format)) !== null) {
    const last = format.length === regex.lastIndex;
    str += match[0];

    if (!last) {
      str += separator;
    }
  }

  return str;
};

export const messageRow = (locale, fixed) => ({
  message: fixed ? locale['wireImports.messageRow.message'] : null
});

const columns = ({ data: { charges, fixed }, locale }) =>
  [
    {
      field: 'displayName',
      formatter: (value, item) => `${value} ${item.size > 0 ? `(${item.size})` : ''}`,
      title: locale['importMapping.title.fieldName']
    },
    {
      field: 'trimLeadingBlanks',
      title: locale['wireImports.title.blanks'],
      formatter: (value) => getFormattedValue(value),
      columnGroup: 'trimLeading',
      columnHeading: locale['wireImports.groupTitle.trimLeading'],
      columnSpan: 2
    },
    {
      field: 'trimLeadingZeros',
      title: locale['wireImports.title.zeros'],
      formatter: (value) => getFormattedValue(value),
      noColumnHeading: true
    },
    {
      field: 'specialFormatting',
      title: locale['importMapping.title.specialFormatting'],
      formatter: (value, item) => (
        <>
          {item.amountDecimal && (
            <Checkbox
              checked={item.amountDecimal === 'Y'}
              disabled
              id="amuntDecimal"
              label="use decimal"
            />
          )}
          {formatDateWithSeparator(value, item) || '-'}
        </>
      )
    },
    {
      field: 'fieldPosition',
      title: fixed
        ? locale['importMapping.title.start']
        : locale['importMapping.title.fieldPosition'],
      columnGroup: fixed ? 'fieldPosition' : null,
      columnHeading: fixed ? locale['wireImports.groupTitle.fieldPosition'] : null,
      columnSpan: 2
    },
    fixed && {
      field: 'fieldLength',
      title: locale['importMapping.title.length'],
      noColumnHeading: true
    },
    {
      field: 'replacementValue',
      title: locale['importMapping.title.replacementValue'],
      formatter: (value) => {
        const found = charges.source.find((c) => c.id === value);
        return found ? found.name : value || '-';
      }
    }
  ].filter(Boolean);

export default columns;
